import client, { PRIVATE_CLIENT } from '../../services/client';
import { parseMobile } from '../../services/utils';
import sessionStore from '../../store/session';
import { get } from 'svelte/store';
import '../../types/call';
export const saveCallNote = async ({ call_id, call_log_id, note }) => {
    const { business_number } = get(sessionStore).receiver;
    const { id: business_number_id, phone_number } = business_number;
    return await client.post('telephony/call-notes/with-log/', PRIVATE_CLIENT, {
        business_number_id,
        call_id,
        call_log_id,
        contact_number: parseMobile(phone_number),
        date_created: new Date().toISOString(),
        note
    });
};
export const updateCallNote = async ({ call_id, call_log_id, note }) => {
    return await client.patch(`telephony/call-notes/id/${call_log_id}/`, PRIVATE_CLIENT, {
        note
    });
};
export const addSurvey = async (business_id, payload) => {
    return await client.post(`business/${business_id}/survey/`, PRIVATE_CLIENT, payload);
};
